<template>
    <div class="www pt-6 pb-2 select-none">
        <div class="pb-2 text-base font-medium text-gray-700">
            {{ t('templateMeta') }}
        </div>
        <div class="www py-2">
            <label
                for="originCode"
                class="block text-sm font-medium text-gray-700 select-none"
            >
                {{ t('templateMetaOrigin') }}
            </label>
            <input
                id="originCode"
                v-model="templateEditModel.template.meta.data.originCode"
                type="text"
                name="originCode"
                autocomplete="off"
                class="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            />
        </div>
        <div class="www py-2">
            <label
                for="author"
                class="block text-sm font-medium text-gray-700 select-none"
            >
                {{ t('templateMetaAuthor') }}
            </label>
            <input
                id="author"
                v-model="templateEditModel.template.meta.data.author"
                type="text"
                name="author"
                autocomplete="off"
                class="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            />
        </div>
        <div class="www py-2">
            <label
                for="keywords"
                class="block text-sm font-medium text-gray-700 select-none"
            >
                {{ t('templateMetaKeywords') }}
            </label>
            <input
                id="keywords"
                v-model="templateEditModel.template.meta.data.keywords"
                type="text"
                name="keywords"
                autocomplete="off"
                class="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            />
        </div>
    </div>
</template>

<script setup>
    import { t } from '../composables/i18n';

    defineExpose({
        name: 'MetaWidget',
    });

    const props = defineProps({
        templateEditModel: {
            type: Object,
            required: true,
        },
    });

    const templateEditModel = props.templateEditModel;
</script>
